import React, { useState,useEffect } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import "react-datepicker/dist/react-datepicker.css";  
import CommonAPI from '../Common/CommonAPI';
import CommonAPI2 from '../Common/FD_BILL_APIs';
import FadeLoader from "react-spinners/HashLoader"; 
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { SegmentedControl } from 'segmented-control'
import { setDefaultLocale } from 'react-datepicker';
import Carousel from 'react-bootstrap/Carousel';
import SegmentedControlWithoutStyles from 'segmented-control/SegmentedControlWithoutStyles';
import { Table } from 'react-bootstrap';
import FDLoanPayments from "./FDLoanPayments";

function FDDetails  (props)  {   

    const [SuccessLoading,setSuccessLoading] =useState(false);
    const [FDList,setFDList]  =useState([]);
    const [SegmentChange,setSegmentChange]  =useState();
    const [FDLoanList,setFDLoanList]  =useState([]);
    const [DepositAmount,setDepositAmount]  =useState();
    const [InterestRate,setInterestRate]  =useState();
    const [TotalInterestAmount,setTotalInterestAmount]  =useState();
    const [DepositDate,setDepositDate]  =useState();
    const [FDnumber,setFDnumber]  =useState();
    const [MaturityDate,setMaturityDate]  =useState();
    const [Period,setPeriod]  =useState();
    const [Type,setType]  =useState();
    const [InterestRequiredMethod,setInterestRequiredMethod]  =useState();      
    const [UptodateInt,setUptodateInt]  =useState();
    const [FirstMonthInterest,setFirstMonthInterest]  =useState();
    const [LastMonthInterest,setLastMonthInterest]  =useState();
    const [MonthlyInterest,setMonthlyInterest]  =useState();
    const [LoanOutStanding,setLoanOutStanding]  =useState();
    const [AccountOpInstruction,setAccountOpInstruction]  =useState();
    const [Customers,setCustomers]  =useState([]);
    const [MainHolder,setMainHolder]  =useState([]);
    const [JoinHolder,setJoinHolder]  =useState([]);
    const [InterestBearer,setInterestBearer]  =useState([]);
    const [Nominee,setNominee]  =useState([]);
    const [CheckFDPayments,setCheckFDPayments] = useState(false);
   
    const ResponseLoadingModal = () => {
        return(
        <Modal
        size="lg"
        centered 
        className="loading1" show={SuccessLoading}>          
            <FadeLoader
            height={25}
            width={5}
            radius={2}
            margin={2}
            color={"#197b55"}
            size={"80px"} this also works
            loading={SuccessLoading}
            />       
        </Modal>
        )
      }

    const GetFDAPI  = () =>{
        setSuccessLoading(true);
        CommonAPI2.GetFDMoreInfo((result) =>{   
            if(result){                    
                setFDList(result.fdHistory);
                setFDLoanList(result.fdLoan);
                setFDnumber(result.fdNumber);
                setInterestRate(result.interestRate);
                setDepositAmount(result.depositAmount);
                setTotalInterestAmount(result.totalInterestAmount);
                setDepositDate(result.depositDate)
                setMaturityDate(result.matirutyDate);
                setPeriod(result.period);
                setType(result.type);
                setInterestRequiredMethod(result.interestPaymentMode==="A"?"At Maturity":"M"?"Monthly":"Q"?"Quarterly":null);               
                setUptodateInt (result.paidAmount);
                setFirstMonthInterest (result.firstMonthInterest);
                setLastMonthInterest(result.lastMonthInterest)
                setMonthlyInterest (result.monthlyInterest);
                setLoanOutStanding (result.loanOutStanding);
                setAccountOpInstruction (result.acOpInstruction);
                setCustomers(result.customers);
                setMainHolder(result.customers.filter(e=>e.mainHolder==true));
                setJoinHolder(result.customers.filter(e=>e.joinHolder==true));
                setInterestBearer (result.customers.filter(e=>e.interestBearer==true));
                setNominee(result.customers.filter(e=>e.nominee==true));
                setSuccessLoading(false);
            }            
        });
      } 

    useEffect( () => {
        GetFDAPI();  
      },[])  ;

    
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:true,
        //centerMode:true,
        //autoplay: true,
        autoplaySpeed: 5000,
        nextArrow:'' ,
        prevArrow:'',
      };

      var periodMonth = '';

        switch (Period) {
            case "1":  periodMonth=1;break;
            case "2":  periodMonth=3;break;
            case "3":  periodMonth=6;break;
            case "4":  periodMonth=12;break;
            case "5":  periodMonth=24;break;
            case "6":  periodMonth=36;break;
            case "7":  periodMonth=48;break;
            case "8":  periodMonth=60;break;
            case "9":  periodMonth=2;break;
            case "10": periodMonth=30;break;
            case "11": periodMonth=34;break;
            case "12": periodMonth=15;break;
            case "13": periodMonth=18;break;
            default: break;
        }
    const FDPaymentsDetails = (ind) =>{
        var FdInfor = {
            fdNumber: ind.fdNumber,
            id:ind.id,
        }
        var value = JSON.stringify(FdInfor);
        sessionStorage.setItem('fdValue', value );
        setCheckFDPayments(true)
     }

    var arry  = FDList.map(( listValue, index ) => {return (listValue.totalInterest)})
    var  TotalInterestSum = arry.reduce((acc,val)=>{
                                 return acc+val;
                               },0)
    var arry1  = FDList.map(( listValue, index ) => {return (listValue.taxAmount)})
    var paidInterest = arry1.reduce((acc,val)=>{
                                return acc+val;
                            },0)
    var arry2  = FDList.map(( listValue, index ) => {return (listValue.paidInterest)})
    var balanceInterest = TotalInterestSum - paidInterest

    if(SuccessLoading){
        return(  <ResponseLoadingModal />)
    }else if(CheckFDPayments){    
        return(<FDLoanPayments isOpen={CheckFDPayments} toggle={()=>setCheckFDPayments(!CheckFDPayments)}/>);
    } 
    return(
            <Modal  
                show={props.show}             
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered 
                backdrop="static"
                onHide={props.onHide}
                >
                <div id="printdiv">
                <Modal.Header closeButton>
                    <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                    <p className='modal-head-f'>FIXED DEPOSIT</p><br/>DETAILS
                    </Modal.Title>
                </Modal.Header>
                    <Modal.Body>
                    <Form >
                    <SegmentedControl
                        name="oneDisabled"
                        options={[
                            { label: "FIXED DEPOSIT INFORMATION" , value: "one", default: true },
                            { label: "FIXED DEPOSIT LOANS", value: "two" },
                            { label: "RENEWAL HISTORY", value: "three" },
                        ]}
                        setValue={newValue => setSegmentChange(newValue)}
                        style={{color:'#197b55',fontSize:13,borderRadius:4,height:38}}
                        />
                    {SegmentChange==="one"?
                    <Row lg={12}> 
                        <Carousel className='block' variant="dark" interval={100000}>
                            <Carousel.Item className='block2' >
                                <center><h3 className='t-font-c'>Fixed Deposit Information</h3></center>
                                   
                                <Row   className='fd_row'>                                
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text'>Fixed Deposit Number</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} >
                                        <div>
                                        <p className='fd-text '>{FDnumber}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Interest Rates</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{parseFloat(InterestRate).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} % </p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row block'>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text'>Capital</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text'>LKR {parseFloat(DepositAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Total Interest</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '> LKR {parseFloat(TotalInterestAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} </p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row block'>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Date Of Deposit</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{moment(DepositDate).format('DD/MM/YYYY')}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Loan Outstanding</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>LKR {LoanOutStanding} </p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row block'>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Date Of Maturity</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{moment(MaturityDate).format('DD/MM/YYYY')}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Period Of Deposit (Month)</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{periodMonth} </p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row block'>
                                    <Col lg={3}  className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Type Of Deposit</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{Type}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Interest Paid Upto Date</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>LKR {parseFloat(UptodateInt).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row block'>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Account Operating Instruction</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{AccountOpInstruction}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Interest Rrequired Method</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{InterestRequiredMethod}</p>
                                        </div>
                                    </Col>                               
                                </Row> 
                                {InterestRequiredMethod=="At Maturity"? 
                                <Row></Row>:                              
                                <Row   className='fd_row block'>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>First Month Interest</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>LKR {parseFloat(FirstMonthInterest).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Last Month Interest</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>LKR {parseFloat(LastMonthInterest).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                        </div>
                                    </Col>                               
                                </Row>
                                }
                                {InterestRequiredMethod=="At Maturity"? 
                                <Row></Row>:
                                <Row   className='fd_row block'>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Monthly Interest</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '> LKR {parseFloat(MonthlyInterest).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '></p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '></p>
                                        </div>
                                    </Col>                               
                                </Row>
                                }
                          
                            </Carousel.Item>
                            <Carousel.Item className='block2' >
                                <center><h3 className='t-font-c'>Fixed Deposit Holders Information</h3></center>
                               
                                {MainHolder.length? MainHolder.map(( listValue, index )=>{
                                   return ( 
                                    <div >
                                   <Row   className='fd_row '>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Full Name</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{listValue.customerName}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Id Number</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{listValue.preferredNIC} </p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>First name</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.lastName}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Passport Number</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.passportNo} </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Initials</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.firstName}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Business Reg.No</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.businessRegNo} </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Address</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.addressLine1}{listValue.addressLine2}, {listValue.addressLine3}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '></p>
                                    </div>
                                </Col>
                                <Col lg={3} >
                                    <div>
                                    <p className='fd-text '> </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row  className='fd_row block'></Row>
                                
                            </div>);
                                }):null
                                }
                                {JoinHolder.length? JoinHolder.map(( listValue, index )=>{
                                   return ( 
                                    <div>
                                   <Row   className='fd_row '>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Full Name</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{listValue.customerName}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Id Number</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{listValue.preferredNIC} </p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>First name</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.lastName}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Passport Number</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.passportNo} </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Initials</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.firstName}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Business Reg.No</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.businessRegNo} </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Address</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.addressLine1}{listValue.addressLine2}, {listValue.addressLine3}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '></p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '> </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row   className='fd_row block'></Row>
                            </div>);
                                }):null
                                }
                                
                                
                            </Carousel.Item>
                            <Carousel.Item className='block2'>
                                    <center><h3 className='t-font-c'>Fixed Deposits Interest Payable Information</h3></center>
                                    {InterestBearer.length? InterestBearer.map(( listValue, index )=>{
                                   return ( 
                                    <div >
                                   <Row   className='fd_row '>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Surname</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{listValue.lastName}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Id Number</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{listValue.preferredNIC} </p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>First name</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.otherName}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Passport Number</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.passportNo} </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Initials</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.firstName}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Business Reg.No</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.businessRegNo} </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Address</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '> {listValue.addressLine1},{listValue.addressLine2} ,{listValue.addressLine3}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Tax File Number</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '> {listValue.taxFileNo}</p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row  className='fd_row block'>
                               
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '> Tax Rate</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '> {listValue.whtTaxRate}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Int.Pay Method</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '> {listValue.typeOfPayment==='C'?'Cash':listValue.typeOfPayment==='Q'?'Cheque':listValue.typeOfPayment==='B'?'Bank Transfer':listValue.typeOfPayment}</p>
                                    </div>
                                </Col>     
                                </Row>
                                
                            </div>);
                                }):null
                                }
                            </Carousel.Item>
                            <Carousel.Item className='block2'>
                            <center><h3 className='t-font-c'>Nominees Information</h3></center>
                                    {Nominee.length? Nominee.map(( listValue, index )=>{
                                   return ( 
                                    <div >
                                   <Row   className='fd_row '>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Surname</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{listValue.lastName}</p>
                                        </div>
                                    </Col>
                                    <Col lg={3} className='fd-bottom'>
                                        <div>
                                        <p className='fd-text '>Id Number</p>
                                        </div>
                                    </Col>
                                    <Col lg={3}>
                                        <div>
                                        <p className='fd-text '>{listValue.preferredNIC} </p>
                                        </div>
                                    </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>First name</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.otherName}</p>
                                    </div>
                                </Col>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Passport Number</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.passportNo} </p>
                                    </div>
                                </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Initials</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '>{listValue.firstName}</p>
                                    </div>
                                </Col>
                                <Col lg={3}>                                    
                                </Col>
                                <Col lg={3}>                                    
                                </Col>                               
                                </Row>
                                <Row   className='fd_row '>
                                <Col lg={3} className='fd-bottom'>
                                    <div>
                                    <p className='fd-text '>Address</p>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div>
                                    <p className='fd-text '> {listValue.addressLine1},{listValue.addressLine2} ,{listValue.addressLine3}</p>
                                    </div>
                                </Col>
                                <Col lg={3}>                                    
                                </Col>
                                <Col lg={3}>                                    
                                </Col>                               
                                </Row>
                            </div>);
                                }):null
                                }
                            </Carousel.Item>
                            </Carousel>                                                    
                    </Row> 
                    :SegmentChange==="two"?
                        <div >
                            <center><h3 className='t-font-c'>View Fixed Deposits Loans</h3></center>
                        <Table   className='block-top' hover responsive>
                            <thead >
                                <tr>
                                <th className='td-width5'>Loan Date</th>
                                <th className='td-width5'>FD Number</th>
                                <th className='td-width5'>Status</th>
                                <th className='td-width5'>Capital Given</th>
                                <th className='td-width5'>Interest Paid</th>
                                <th className='td-width5'>VAT Paid</th>
                                <th className='td-width5' >Total Paid</th>
                                <th className='td-width5'>Loan Outstanding</th>
                                <th className='td-width5'>Capital Outstanding</th>
                                <th className='td-width5'>Int + VAT Outstanding</th>
                                <th className='td-width5'>Payments</th>                            
                                </tr>
                            </thead>
                            <tbody>
                            {FDLoanList.length? FDLoanList.map(( listValue, index )=>{
                            return ( 
                                <tr>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{moment(listValue.date).format('DD/MM/YYYY')}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{listValue.fdNumber}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{listValue.status}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{listValue.loanAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{listValue.totalInterest.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{(listValue.vatPaid).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{listValue.totalPaid.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{listValue.loanOutstanding.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{listValue.loanCapitalOutstanding.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <p className='tb-text m-top'>{listValue.interestVATOutstanding.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width5'>
                                    <Button 
                                     onClick={()=>FDPaymentsDetails(listValue)}  
                                    className='btn-browse' 
                                    variant="primary" type="submit">
                                        Payments
                                    </Button>
                                </td>                            
                            </tr>);
                                }):null
                                }
                            </tbody>
                        </Table>
                          
                        </div>
                    :SegmentChange==="three"?
                    <div >
                    <center><h3 className='t-font-c'>Fixed Deposit Renewal History</h3></center>
                    <Row   className='fd_row '>
                        <Col lg={3} className='fd-bottom'>
                            <div>
                            <p className='fd-text '>Fixed Deposit Number</p>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div>
                            <p className='fd-text '>{FDnumber}</p>
                            </div>
                        </Col>
                        <Col lg={3} className='fd-bottom'>
                            <div>
                            <p className='fd-text '>Total Interest</p>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div>
                            <p className='fd-text '>LKR {parseFloat(TotalInterestSum).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} </p>
                            </div>
                        </Col>                               
                    </Row>
                    <Row   className='fd_row '>
                        <Col lg={3} className='fd-bottom'>
                            <div>
                            <p className='fd-text '>Interest Paid</p>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div>
                            <p className='fd-text '>LKR {parseFloat(balanceInterest).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                            </div>
                        </Col>
                        <Col lg={3} className='fd-bottom'>
                            <div>
                            <p className='fd-text '></p>
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div>
                            <p className='fd-text '> </p>
                            </div>
                        </Col>                               
                    </Row>
                    <Table   className='block-top' hover responsive>
                        <thead >
                            <tr>
                            <th className='td-width2'>Deposit Amount</th>
                            <th className='td-width2'>Deposited On</th>
                            <th className='td-width2'>Period</th>
                            <th className='td-width2'>Matured On</th>
                            <th className='td-width2'>Rate</th>
                            <th className='td-width2'>Total Interest</th>
                            <th className='td-width2' >Paid Interest</th>
                            <th className='td-width2'> Tax</th>                            
                            </tr>
                        </thead>
                        <tbody>
                        {FDList.length?FDList.map(( listValue, index )=>{
                        return ( 
                            <tr>
                            <td className='td-width2'>
                                <p className='tb-text m-top'>{listValue.depositAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width2'>
                                <p className='tb-text m-top'>{listValue.depositDate}</p>
                                </td>
                                <td className='td-width2'>
                                <p className='tb-text m-top'>{listValue.periodInMonths}</p>                              
                           </td>
                           <td className='td-width2'>
                                <p className='tb-text m-top'>{listValue.maturityDate}</p>
                                </td>
                                <td className='td-width2'>
                                <p className='tb-text m-top'>{parseFloat(listValue.intrestRate).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} %</p>
                                </td>
                                <td className='td-width2'>
                                <p className='tb-text m-top'>{listValue.totalInterest.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width2'>
                                <p className='tb-text m-top'>{parseFloat(listValue.totalInterest-listValue.taxAmount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>
                                <td className='td-width2'>
                                <p className='tb-text m-top'>{parseFloat(listValue.taxAmount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                </td>                                            
                        </tr>
                        );
                        }):null
                    }
                        </tbody>
                    </Table>                    
                    
                </div>
                    :null
                }
                        
                    </Form>                                   
                    </Modal.Body>
                </div>
                  
            </Modal>
            );

}
export default FDDetails;